var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',_vm._l((_vm.movies),function(movie){return _c('b-col',{key:movie.imdbId,attrs:{"cols":"6","md":"3"}},[_c('MoviePoster',{attrs:{"poster":movie.poster,"title":movie.title}})],1)}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }